(function (global) {
  'use strict';
  // Local candidate factory. No automatic installation, network, storage or UI.
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var TRUST = 'client_reported_provider_privacy_state/server_recorded';
  var TIMESTAMP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,6})?(?:Z|[+-]\d{2}:\d{2})$/;
  var STORAGE_KEY = 'mjc_meguri_analytics_epochs_v1:modern-japan-crafts:mjc-browser-consented-20260925-v1';
  function exact(value, keys) {
    return value && typeof value === 'object' && !Array.isArray(value) &&
      Object.keys(value).sort().join('|') === keys.slice().sort().join('|');
  }
  function readPrivacy(shopify) {
    try {
      var api = shopify.customerPrivacy;
      var permission = api.analyticsProcessingAllowed();
      var choice = api.currentVisitorConsent().analytics;
      return { processing_permission: permission === true ? true : (permission === false ? false : null),
        visitor_choice: choice === '' ? 'unset' : (choice === 'yes' || choice === 'no' ? choice : 'unavailable') };
    } catch (e) { return { processing_permission: null, visitor_choice: 'unavailable' }; }
  }
  function routes(config, origin) {
    if (!config || config.enabled !== true || config.productionEnabled !== true ||
        ['https://modernjapancrafts.com', 'https://www.modernjapancrafts.com'].indexOf(origin) < 0 ||
        !Array.isArray(config.allowedEndpoints) || config.allowedEndpoints.length > 8) return null;
    var result = {};
    try {
      ['evidenceEndpoint', 'eventsEndpoint'].forEach(function (key) {
        var url = new URL(config[key]);
        if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || url.port ||
            !/^[a-z0-9-]+(?:\.[a-z0-9-]+)+$/.test(url.hostname) || /^[\d.]+$/.test(url.hostname) ||
            url.hostname.endsWith('.localhost') || config.allowedEndpoints.indexOf(url.href) < 0) throw new Error('unbound');
        result[key] = url.href;
      });
      if (result.evidenceEndpoint === result.eventsEndpoint) return null;
      return result;
    } catch (e) { return null; }
  }
  function create(options) {
    var bound = routes(options.config, options.origin);
    var now = options.now || Date.now;
    var timer = options.setTimeout || setTimeout, untimer = options.clearTimeout || clearTimeout;
    var current = null, history = [], pending = new Set(), draining = false, ready = false;
    var used = new Set(), expiryTimer = null, disposed = false;
    var loaded = false, storageFailed = false;
    // Only post-ACK observations enter this memory-only transport queue.
    var eventQueue = [], eventActive = null, eventBytes = 0, eventGeneration = 0;
    function load() {
      if (loaded) return !storageFailed;
      loaded = true;
      try {
        var raw = options.storage.getItem(STORAGE_KEY);
        if (raw === null) return true;
        if (raw.length > 20000) throw new Error('invalid');
        var saved = JSON.parse(raw), ids = new Set();
        if (!exact(saved, ['format', 'epochs']) || saved.format !== 'mjc-analytics-epochs.v1' ||
            !Array.isArray(saved.epochs) || saved.epochs.length > 32) throw new Error('invalid');
        saved.epochs.forEach(function (item) {
          if (!exact(item, ['session_id', 'epoch_id', 'transition_id']) || !UUID.test(item.session_id) ||
              !UUID.test(item.epoch_id) || ids.has(item.epoch_id) ||
              (item.transition_id !== null && !UUID.test(item.transition_id))) throw new Error('invalid');
          ids.add(item.epoch_id);
        });
        history = saved.epochs.map(function (item) {
          return { session: item.session_id, id: item.epoch_id, withdrawal: item.transition_id, attempted: false };
        });
        return true;
      } catch (e) { storageFailed = true; return false; }
    }
    function persist() {
      try {
        if (!history.length) {
          options.storage.removeItem(STORAGE_KEY);
          if (options.storage.getItem(STORAGE_KEY) !== null) throw new Error('unconfirmed');
        } else {
          var raw = JSON.stringify({ format: 'mjc-analytics-epochs.v1', epochs: history.map(function (epoch) {
            return { session_id: epoch.session, epoch_id: epoch.id, transition_id: epoch.withdrawal || null };
          }) });
          options.storage.setItem(STORAGE_KEY, raw);
          if (options.storage.getItem(STORAGE_KEY) !== raw) throw new Error('unconfirmed');
        }
        return true;
      } catch (e) { storageFailed = true; return false; }
    }
    function uuid() { var value = options.uuid(); return UUID.test(value) ? value : null; }
    function eligible() {
      try { var p = options.readPrivacy(); return p.processing_permission === true && p.visitor_choice === 'yes'; }
      catch (e) { return false; }
    }
    function unavailable() {
      try { var p = options.readPrivacy(); return p.visitor_choice !== 'no' && (p.processing_permission === null || p.visitor_choice === 'unavailable'); }
      catch (e) { return true; }
    }
    function session() { try { return options.getSession(); } catch (e) { return null; } }
    function notify(value) {
      if (ready === value) return;
      ready = value;
      try { options.onReady(value); } catch (e) { /* Observation never interrupts storefront. */ }
    }
    function cancelJobs() {
      eventGeneration++; eventQueue = []; eventActive = null; eventBytes = 0;
      pending.forEach(function (job) { job.cancel(); }); pending.clear();
    }
    function stop() {
      current = null; untimer(expiryTimer); expiryTimer = null;
      cancelJobs(); notify(false);
    }
    // Bounded retry uses byte-identical bodies, including the transition/event ID.
    function request(url, body, guard, tracked, timeoutMs) {
      timeoutMs = timeoutMs || 5000;
      return new Promise(function (resolve) {
        var done = false, timeout = null, retry = null, controller = null, generation = 0;
        var job = { cancel: function () { finish(null); } };
        function finish(value) {
          if (done) return; done = true; untimer(timeout); untimer(retry);
          if (controller) controller.abort(); pending.delete(job); resolve(value);
        }
        if (tracked) pending.add(job);
        function attempt(count) {
          if (done || !guard()) { finish(null); return; }
          var token = ++generation;
          controller = new AbortController();
          // One total watchdog per attempt covers headers AND body, not two budgets.
          timeout = timer(function () { controller.abort(); failed(count, token); }, timeoutMs);
          var response;
          try { response = options.fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: body, credentials: 'omit', referrerPolicy: 'no-referrer', redirect: 'error',
            keepalive: true, signal: controller.signal }); } catch (e) { failed(count, token); return; }
          Promise.resolve(response).then(function (res) {
            if (done || token !== generation) return;
            if (!res || !res.ok) {
              if (!res || res.status === 429 || res.status >= 500) failed(count, token);
              else finish(null);
              return;
            }
            // Keep the original attempt deadline while parsing the response body.
            Promise.resolve().then(function () { return res.json(); }).then(function (value) {
              if (token === generation) finish(value);
            }, function () { if (token === generation) finish(null); });
          }, function () { failed(count, token); });
        }
        function failed(count, token) {
          if (done || token !== generation) return;
          generation++; untimer(timeout);
          if (count === 0 && guard()) retry = timer(function () { attempt(1); }, 500);
          else finish(null);
        }
        attempt(0);
      });
    }
    function drainWithdrawals() {
      if (draining) return;
      var epoch = history.find(function (item) { return item.withdrawal && !item.attempted; });
      if (!epoch) return;
      draining = true; epoch.attempted = true;
      var body = JSON.stringify({ format: 'meguri-anonymous-analytics-evidence.v1', action: 'withdraw',
        session_id: epoch.session, epoch_id: epoch.id, transition_id: epoch.withdrawal });
      // Match the receiver's 12s work budget with the same bounded 15s attempt as events.
      request(bound.evidenceEndpoint, body, function () { return true; }, false, 15000).then(function (ack) {
        if (validAckShape(ack, epoch) && ack.status === 'revoked') {
          history = history.filter(function (item) { return item !== epoch; }); persist();
        }
        // Finite sequential work <=4 first attempts/s, below receiver 5rps; retry once.
        // Unknown ACK stays pending, with the same transition across a later reload.
        timer(function () {
          draining = false; drainWithdrawals();
          if (!draining && !history.some(function (item) { return item.withdrawal; }) && !disposed) refresh();
        }, 250);
      });
    }
    function withdrawAll() {
      history.forEach(function (epoch) { if (!epoch.withdrawal) epoch.withdrawal = uuid(); });
      persist(); drainWithdrawals();
    }
    function validAckShape(ack, epoch) {
      return exact(ack, ['format', 'status', 'epoch_id', 'session_id', 'permission_receipt_sha256', 'issued_at', 'expires_at', 'trust']) &&
        ack.format === 'meguri-anonymous-analytics-evidence-receipt.v1' &&
        ack.epoch_id === epoch.id && ack.session_id === epoch.session && ack.trust === TRUST &&
        (ack.permission_receipt_sha256 === null || (typeof ack.permission_receipt_sha256 === 'string' && /^[a-f0-9]{64}$/.test(ack.permission_receipt_sha256))) &&
        typeof ack.issued_at === 'string' && typeof ack.expires_at === 'string' && TIMESTAMP.test(ack.issued_at) && TIMESTAMP.test(ack.expires_at) &&
        Number.isFinite(Date.parse(ack.issued_at)) && Number.isFinite(Date.parse(ack.expires_at)) && Date.parse(ack.issued_at) < Date.parse(ack.expires_at);
    }
    function validAck(ack, epoch) {
      if (!validAckShape(ack, epoch) || ack.status !== 'active' || ack.permission_receipt_sha256 === null) return false;
      var issued = Date.parse(ack.issued_at), expires = Date.parse(ack.expires_at);
      // Server controls finite TTL (300s initially). Never extend it or adjust the clock.
      return Number.isFinite(issued) && Number.isFinite(expires) && issued <= now() &&
        issued < expires && expires > now();
    }
    function scheduleExpiry(epoch) {
      untimer(expiryTimer);
      // Long owner-selected TTLs must not overflow browser setTimeout.
      expiryTimer = timer(function () { if (current === epoch) refresh(); }, Math.min(epoch.expires - now(), 2147483647));
    }
    function refresh() {
      if (!bound || disposed) return false;
      if (!load()) return false;
      if (!eligible()) {
        stop();
        // A loading/missing native API is not an explicit withdrawal decision.
        if (unavailable()) { drainWithdrawals(); return false; }
        try { options.clearIdentity(); } catch (e) {}
        withdrawAll(); return false;
      }
      if (history.some(function (epoch) { return epoch.withdrawal; })) {
        stop(); try { options.clearIdentity(); } catch (e) {}
        drainWithdrawals(); return false;
      }
      if (draining || storageFailed) return false;
      var sid = session();
      if (!UUID.test(sid)) { stop(); return false; }
      if (current && (current.session !== sid || (current.expires && current.expires <= now()))) stop();
      if (current) { if (current.expires) scheduleExpiry(current); return ready; }
      // No eviction: retain all tab-local epochs, including across reload, until revoked ACK.
      // Bound memory/network; reaching the cap stops observation without losing handles.
      if (history.length >= 32) return false;
      var id = uuid(), transition = uuid(); if (!id || !transition) return false;
      var epoch = { id: id, session: sid, expires: null, ack: null, withdrawal: null, attempted: false };
      current = epoch; history.push(epoch);
      if (!persist()) { stop(); return false; }
      var body = JSON.stringify({ format: 'meguri-anonymous-analytics-evidence.v1', action: 'observe',
        session_id: sid, epoch_id: id, transition_id: transition, processing_permission: true, visitor_choice: 'yes' });
      request(bound.evidenceEndpoint, body, function () { return current === epoch && eligible(); }, true, 15000).then(function (ack) {
        if (current !== epoch || !eligible() || session() !== sid) { refresh(); return; }
        if (!validAck(ack, epoch)) return; // Failed/unknown write remains blocked, no automatic new epoch.
        epoch.ack = ack; epoch.expires = Date.parse(ack.expires_at);
        scheduleExpiry(epoch); notify(true);
      });
      return false;
    }
    function allowed() { return refresh() && ready; }
    function utf8Bytes(value) {
      var bytes = 0;
      for (var i = 0; i < value.length; i++) {
        var code = value.charCodeAt(i);
        if (code <= 0x7f) bytes++;
        else if (code <= 0x7ff) bytes += 2;
        else if (code >= 0xd800 && code <= 0xdbff && value.charCodeAt(i + 1) >= 0xdc00 && value.charCodeAt(i + 1) <= 0xdfff) { bytes += 4; i++; }
        else bytes += 3;
      }
      return bytes;
    }
    function pumpEvents() {
      if (eventActive) return;
      while (eventQueue.length) {
        var item = eventQueue.shift(), generation = eventGeneration;
        // No epoch relabeling: expired/withdrawn/session-replaced actions are dropped.
        if (current !== item.epoch || !allowed()) {
          if (generation === eventGeneration) eventBytes -= item.bytes;
          if (generation !== eventGeneration || eventActive) return;
          continue;
        }
        eventActive = item;
        request(bound.eventsEndpoint, item.body, function () {
          return generation === eventGeneration && current === item.epoch && allowed();
        }, true, 15000).then(function () {
          if (generation !== eventGeneration) return;
          eventBytes -= item.bytes; eventActive = null; pumpEvents();
        });
        return;
      }
    }
    function send(factory) {
      if (typeof factory !== 'function' || !allowed() || eventQueue.length + (eventActive ? 1 : 0) >= 20 || used.size >= 4096) return false;
      var epoch = current, id = uuid(); if (!id || used.has(id)) return false;
      var timestamp = now(), event;
      try { event = factory({ client_event_id: id, occurred_at: new Date(timestamp).toISOString() }); } catch (e) { return false; }
      if (!exact(event, ['schema_version', 'event_name', 'source', 'client_event_id', 'anonymous_id', 'session_id', 'occurred_at', 'properties', 'trace']) ||
          event.schema_version !== '1.2.0' || event.client_event_id !== id || event.session_id !== epoch.session ||
          event.occurred_at !== new Date(timestamp).toISOString() || timestamp < Date.parse(epoch.ack.issued_at) ||
          !allowed() || current !== epoch) return false;
      var body;
      try { body = JSON.stringify({ format: 'meguri-anonymous-analytics-event.v1', epoch_id: epoch.id,
        permission_receipt_sha256: epoch.ack.permission_receipt_sha256, event: event }); } catch (e) { return false; }
      var bytes = utf8Bytes(body);
      if (eventBytes + bytes > 65536) return false;
      used.add(id); eventBytes += bytes;
      eventQueue.push({ epoch: epoch, body: body, bytes: bytes }); pumpEvents();
      return true;
    }
    return { refresh: refresh, allowed: allowed, send: send, configured: !!bound,
      dispose: function () { disposed = true; stop(); withdrawAll(); try { options.clearIdentity(); } catch (e) {} } };
  }
  global.MJCMeguriAnonymousAnalytics = { create: create, readPrivacy: readPrivacy };
})(window);

(function () {
  'use strict';
  if (window.MJCMeguri) return;

  // S00 browser input 1.1.0; extended behavior explicitly opts into candidate 1.2.0.
  // Canonical IDs, receipt time, identity resolution and
  // verified consent belong to the receiver. Production requires a separate switch
  // and an exact HTTPS endpoint allowlist; all settings default to OFF/empty.
  var node = document.querySelector('[data-meguri-config]');
  var config = {};
  try { config = JSON.parse(node ? node.textContent : '{}'); } catch (e) {}
  var behavior = config.behaviorEnabled === true;
  // Bind the wire version to its receiver route, even when both URLs are allowlisted.
  var receiverPath = behavior ? '/v1.2/events' : '/events';
  var endpoint = null;
  var production = false;
  try {
    var candidate = new URL(config.endpoint);
    var localPage = ['localhost', '127.0.0.1', '[::1]'].indexOf(new URL(window.location.origin).hostname) !== -1;
    var localReceiver = ['localhost', '127.0.0.1', '[::1]'].indexOf(candidate.hostname) !== -1;
    var safeUrl = !candidate.username && !candidate.password && !candidate.search && !candidate.hash;
    var allowlist = typeof config.allowedEndpoints === 'string' ? config.allowedEndpoints.split(/\r?\n/).map(function (value) { return value.trim(); }).filter(Boolean) : [];
    var storefront = ['https://modernjapancrafts.com', 'https://www.modernjapancrafts.com'].indexOf(window.location.origin) !== -1;
    var publicHostname = /^[a-z0-9-]+(?:\.[a-z0-9-]+)+$/.test(candidate.hostname) && !/^[\d.]+$/.test(candidate.hostname) && !localReceiver;
    production = config.enabled === true && config.productionEnabled === true && storefront &&
      safeUrl && publicHostname && candidate.protocol === 'https:' && !candidate.port &&
      candidate.pathname === receiverPath && allowlist.length <= 8 && allowlist.indexOf(candidate.href) !== -1;
    var local = config.enabled === true && localPage && localReceiver && safeUrl &&
      ['http:', 'https:'].indexOf(candidate.protocol) !== -1 &&
      (candidate.pathname === '/mock/meguri' || candidate.pathname === receiverPath);
    if (production || local) endpoint = candidate.href;
  } catch (e) {}

  var storageKey = 'mjc_meguri_session_v1';
  var anonymousKey = 'mjc_meguri_anonymous_v1';
  var sessionTimeout = 30 * 60 * 1000;
  var identity = null;
  var consented = false;
  var externalRevoked = false;
  var listeners = [];
  var pending = new Set();
  var uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var idPattern = /^\d{1,24}$/;
  var signals = {
    article_view: 'engagement.article.viewed',
    engaged_30s: 'engagement.article.engaged',
    read_75pct: 'engagement.article.read',
    recommendation_shown: 'engagement.recommendation.shown',
    recommendation_click: 'engagement.recommendation.clicked',
    newsletter_signup_succeeded: 'identity.email.registered',
    craft_finder_completed: 'engagement.quiz.completed',
    craft_finder_signup_succeeded: 'identity.email.registered'
  };
  if (behavior) Object.assign(signals, {
    session_start: 'engagement.session.started', page_view: 'engagement.page.viewed',
    product_view: 'commerce.product.viewed', cart_add: 'commerce.cart.item_added',
    checkout_intent: 'commerce.checkout.requested', article_reaction: 'engagement.article.reacted'
  });

  function uuid() {
    return window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : null;
  }
  function readIdentity() {
    var now = Date.now();
    if (!identity) try {
      var saved = JSON.parse(window.sessionStorage.getItem(storageKey));
      if (saved && /^anon_[a-f0-9]{32}$/.test(saved.anonymous_id) && uuidPattern.test(saved.session_id)) {
        identity = { anonymous_id: saved.anonymous_id, session_id: saved.session_id,
          last_activity: saved.last_activity, started: saved.started === true };
      }
    } catch (e) {}
    if (identity && behavior && (!Number.isFinite(identity.last_activity) ||
        now - identity.last_activity >= sessionTimeout || now < identity.last_activity)) {
      identity.session_id = uuid(); identity.started = false;
    }
    if (!identity) {
      var anonymous = uuid();
      var session = uuid();
      if (!anonymous || !session) return null;
      identity = { anonymous_id: 'anon_' + anonymous.replace(/-/g, ''), session_id: session };
    }
    if (behavior) {
      // Browser-scoped anonymous ID, never a customer/person ID. No access before consent.
      try {
        var storedAnonymous = window.localStorage.getItem(anonymousKey);
        if (/^anon_[a-f0-9]{32}$/.test(storedAnonymous)) identity.anonymous_id = storedAnonymous;
        else window.localStorage.setItem(anonymousKey, identity.anonymous_id);
      } catch (e) {}
    }
    if (!identity.session_id) return null;
    identity.last_activity = now;
    saveIdentity();
    return identity;
  }
  function saveIdentity() {
    try { window.sessionStorage.setItem(storageKey, JSON.stringify(identity)); } catch (e) {}
  }
  var prospective;
  function refreshConsent() { if (prospective) prospective.refresh(); }
  function allowed() { return !!prospective && prospective.allowed(); }
  function clean(signal, input) {
    if (!Object.prototype.hasOwnProperty.call(signals, signal)) return null;
    var result = {};
    if (signal === 'session_start') {
      return acquisition();
    } else if (signal === 'page_view') {
      if (['index', 'article', 'blog', 'product', 'collection', 'list-collections', 'page', 'cart', 'search', '404', 'password'].indexOf(input.page_type) === -1) return null;
      result.page_type = input.page_type;
    } else if (signal === 'product_view' || signal === 'cart_add') {
      if (typeof input.product_id !== 'string' || !idPattern.test(input.product_id)) return null;
      result.product_id = input.product_id;
      if (input.variant_id !== undefined) {
        if (typeof input.variant_id !== 'string' || !idPattern.test(input.variant_id)) return null;
        result.variant_id = input.variant_id;
      }
      if (signal === 'cart_add') {
        if (!result.variant_id || !Number.isInteger(input.quantity) || input.quantity < 1 || input.quantity > 10000) return null;
        result.quantity = input.quantity;
      }
    } else if (signal === 'checkout_intent') {
      result.checkout_observation = 'theme_intent';
    } else if (['article_view', 'engaged_30s', 'read_75pct', 'article_reaction'].indexOf(signal) !== -1) {
      if (typeof input.article_source_id !== 'string' || !idPattern.test(input.article_source_id) ||
          typeof input.article_source_handle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(input.article_source_handle)) return null;
      result.source_content_id = input.article_source_id;
      result.source_content_handle = input.article_source_handle;
      if (signal === 'engaged_30s') result.threshold_seconds = 30;
      if (signal === 'read_75pct') result.threshold_percent = 75;
      if (signal === 'article_reaction') {
        if (['helpful', 'inspiring', 'surprising', 'not_relevant'].indexOf(input.reaction_code) === -1) return null;
        result.reaction_code = input.reaction_code;
      }
    } else if (/^recommendation_/.test(signal)) {
      if (typeof input.source_content_id !== 'string' || !idPattern.test(input.source_content_id) ||
          typeof input.product_source_id !== 'string' || !idPattern.test(input.product_source_id) ||
          !Number.isInteger(input.position) || input.position < 1 || input.position > 50 ||
          ['article', 'craft_finder'].indexOf(input.surface) === -1) return null;
      result.source_content_id = input.source_content_id;
      result.product_id = input.product_source_id;
      result.recommendation_rank = input.position;
      result.recommendation_policy_version = input.surface === 'article' ? 'article-tags-v2' : 'craft-finder-v1';
      result.recommendation_id = input.surface + ':' + input.source_content_id + ':' + input.product_source_id;
    } else if (signal === 'craft_finder_completed') {
      if (['EA', 'RS', 'MC', 'HK', 'TG', 'MG', 'SG', 'HG'].indexOf(input.quiz_classification) === -1) return null;
      result.quiz_classification = input.quiz_classification;
      if (behavior) result.quiz_version = 'craft-finder-v1';
      if (['TABLE_TEA', 'HOME_ATMOSPHERE', 'STYLE_ACCESSORIES', 'TOOLS_EVERYDAY', 'SURPRISE_ME'].indexOf(input.quiz_interest) !== -1) result.quiz_interest = input.quiz_interest;
      if (behavior && input.quiz_answers) {
        var answers = {};
        ['q1', 'q2', 'q3', 'q4'].forEach(function (key) {
          var choices = key === 'q4' ? ['A', 'B', 'C', 'D', 'E'] : ['A', 'B', 'C', 'D'];
          if (choices.indexOf(input.quiz_answers[key]) !== -1) answers[key] = input.quiz_answers[key];
        });
        if (Object.keys(answers).length === 4) result.quiz_answers = answers;
      }
    } else {
      result.registration_result = 'accepted';
    }
    return result;
  }
  function acquisition() {
    var result = { acquisition_source: 'direct_or_unknown', country: null };
    try {
      var referrer = new URL(document.referrer);
      var host = referrer.hostname;
      if (referrer.origin === window.location.origin) result.acquisition_source = 'internal';
      else if (['google.com', 'www.google.com', 'bing.com', 'www.bing.com'].indexOf(host) !== -1) result.acquisition_source = 'search';
      else if (['youtube.com', 'www.youtube.com', 'youtu.be', 'instagram.com', 'www.instagram.com', 't.co', 'facebook.com', 'www.facebook.com'].indexOf(host) !== -1) result.acquisition_source = 'social';
      else result.acquisition_source = 'referral';
    } catch (e) {}
    try {
      var query = new URL(window.location.href).searchParams;
      var sources = ['youtube', 'instagram', 'facebook', 'google', 'bing', 'klaviyo', 'newsletter', 'kickstarter', 'pinterest'];
      var mediums = ['email', 'social', 'organic', 'paid_social', 'cpc', 'referral', 'video'];
      var campaigns = typeof config.allowedCampaigns === 'string' ? config.allowedCampaigns.split(/\r?\n/).map(function (v) { return v.trim(); }).filter(function (v) { return /^[a-z0-9][a-z0-9_-]{0,63}$/.test(v); }).slice(0, 100) : [];
      [['utm_source', sources], ['utm_medium', mediums], ['utm_campaign', campaigns]].forEach(function (entry) {
        var values = query.getAll(entry[0]);
        if (values.length === 1 && entry[1].indexOf(values[0]) !== -1) result[entry[0]] = values[0];
      });
    } catch (e) {}
    return result;
  }
  function emit(signal, properties) {
    try { return emitSafe(signal, properties); } catch (e) { return false; }
  }
  function emitSafe(signal, properties) {
    refreshConsent();
    if (!allowed() || pending.size >= 20 || typeof window.fetch !== 'function' || typeof AbortController !== 'function') return false;
    var safe = clean(signal, properties || {});
    if (!safe) return false;
    var state = readIdentity();
    var eventId = uuid();
    if (!state || !eventId) return false;
    if (behavior && signal !== 'session_start' && !state.started) {
      if (pending.size > 18) return false;
      var sessionEventId = uuid();
      if (!sessionEventId) return false;
      if (!send('session_start', acquisition(), state, sessionEventId)) return false;
      state.started = true; saveIdentity();
    }
    if (signal === 'session_start') {
      if (state.started) return false;
      state.started = true; saveIdentity();
    }
    return send(signal, safe, state, eventId);
  }
  function send(signal, safe, state, eventId) {
    if (!eventId) return;
    // No URL/referrer, profile/form text, trusted consent, or client person_id.
    return prospective.send(function (fresh) { return {
      schema_version: behavior ? '1.2.0' : '1.1.0', event_name: signals[signal], source: 'shopify',
      client_event_id: fresh.client_event_id, anonymous_id: state.anonymous_id, session_id: state.session_id,
      occurred_at: fresh.occurred_at, properties: safe,
      trace: { producer: 'mjc_theme', producer_version: behavior ? '0.2.0' : '0.1.0' }
    }; });
  }
  function onConsent(listener) {
    listeners.push(listener);
    try { listener(allowed()); } catch (e) {}
    return function () { listeners = listeners.filter(function (item) { return item !== listener; }); };
  }

  var observed = new WeakSet();
  function observeRecommendations(root) {
    if (!endpoint || !window.IntersectionObserver) return;
    root.querySelectorAll('[data-meguri-recommendation]').forEach(function (card) {
      if (observed.has(card)) return;
      observed.add(card);
      var owner = card.closest('[data-article-source-id]');
      var fields = {
        source_content_id: owner ? owner.dataset.articleSourceId : card.dataset.finderSourceId,
        product_source_id: card.dataset.productSourceId,
        position: Number(card.dataset.recommendationPosition),
        surface: owner ? 'article' : 'craft_finder'
      };
      var seen = false;
      var inView = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          show();
        });
      }, { threshold: [0, 0.5] });
      function show() {
        if (!seen && inView && document.visibilityState === 'visible' && allowed()) {
          seen = emit('recommendation_shown', fields);
          if (seen) observer.disconnect();
        }
      }
      var unsubscribe = onConsent(function (value) {
        if (value && !seen) observer.observe(card);
        else observer.disconnect();
      });
      var clicked = function () { emit('recommendation_click', fields); };
      card.addEventListener('click', clicked);
      document.addEventListener('visibilitychange', show);
      // Section replacement and Finder retake call this to release observers.
      card._meguriCleanup = function () {
        observer.disconnect(); unsubscribe();
        document.removeEventListener('visibilitychange', show);
        card.removeEventListener('click', clicked);
        observed.delete(card);
      };
    });
  }
  function releaseRecommendations(root) {
    root.querySelectorAll('[data-meguri-recommendation]').forEach(function (card) {
      if (card._meguriCleanup) card._meguriCleanup();
    });
  }

  prospective = window.MJCMeguriAnonymousAnalytics.create({
    config: endpoint && behavior && production ? config.anonymousAnalytics : null,
    origin: window.location.origin, uuid: uuid,
    storage: window.sessionStorage,
    readPrivacy: function () {
      return externalRevoked ? { processing_permission: false, visitor_choice: 'no' } :
        window.MJCMeguriAnonymousAnalytics.readPrivacy(window.Shopify);
    },
    getSession: function () { var state = readIdentity(); return state && state.session_id; },
    fetch: function (url, init) { return window.fetch(url, init); },
    clearIdentity: function () {
      identity = null;
      pending.forEach(function (job) { job.cancel(); }); pending.clear();
      try { window.sessionStorage.removeItem(storageKey); } catch (e) {}
      try { window.localStorage.removeItem(anonymousKey); } catch (e) {}
    },
    onReady: function (next) {
      consented = next;
      listeners.forEach(function (listener) { try { listener(next); } catch (e) {} });
    }
  });
  window.MJCMeguri = {
    emit: emit, allowed: allowed, onConsent: onConsent,
    behaviorEnabled: behavior,
    observeRecommendations: observeRecommendations, releaseRecommendations: releaseRecommendations,
    status: function () { return prospective.configured ? 'prospective_configured' : 'disabled'; }
  };
  if (prospective.configured) {
    document.addEventListener('visitorConsentCollected', function () { externalRevoked = false; refreshConsent(); });
    if (behavior) window.addEventListener('storage', function (event) {
      if ((event.key === anonymousKey || event.key === null) && event.newValue === null) {
        externalRevoked = true; refreshConsent();
      }
    });
    window.addEventListener('pageshow', refreshConsent);
    refreshConsent();
    // Shopify may load customerPrivacy after this deferred asset.
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) refreshConsent();
      });
    }
  }
})();
